import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { columns } from "src/pages/Patients/utils/columns";
import { Link } from "react-router-dom";
import { PatientProfile } from "src/api/types";
import { Paths } from "src/constants/paths";

interface Props {
  row: PatientProfile;
}

export const PatientTableRow = ({ row }: Props) => {
  return (
    <TableRow hover role="checkbox" tabIndex={-1}>
      {columns.map((column) => {
        return (
          <TableCell
            width={column.minWidth}
            key={column.id}
            align={column.align}
          >
            {column.id === "patient" ? (
              <Link
                to={`${Paths.DASHBOARD_PATIENTS}/${row.id}`}
                target="_blank"
              >
                {column.format(row)}
              </Link>
            ) : (
              column.format(row)
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};
